import { FormInstance } from "antd";
import useFooterStore from "views/hooks/useFooterStore";
import useCoreStore from "views/hooks/useCoreStore";
import { useEffect } from "react";

interface UseFeatureEffectsProps {
  form: FormInstance;
  tabName?: string;
  isSetup?: boolean;
  handleSaveClick: () => void;
}

export const useFeatureEffects = ({
  form,
  tabName,
  isSetup,
  handleSaveClick,
}: UseFeatureEffectsProps) => {
  const handleOkSaveButton = useFooterStore(state => state.handleOkSaveButton);
  const data = useCoreStore(state => state.companySettings);

  useEffect(() => {
    if (!data) return;

    const fieldsData = [
      {
        name: "defaultPriceType",
        value: data.defaultPriceType?.value !== "net",
      },
      {
        name: "saleDocumentTypes",
        value:
          (data.saleDocumentTypes?.length > 0 && data.saleDocumentTypes.map(item => item.value)) ||
          (isSetup && ["purchase_order", "receipt", "budget"]),
      },
      {
        name: "availabilityTime",
        value: data.availabilityTime,
      },
      {
        name: "sendOverdueEmail",
        value: data.sendOverdueEmail,
      },
      {
        name: "clientHasAutoNumber",
        value: data.clientHasAutoNumber,
      },
      {
        name: "analyticalType",
        value: data.analyticalType,
      },
      {
        name: "counterpartProductAllocationType",
        value: data.counterpartProductAllocationType?.value,
      },
    ];

    form.setFields(fieldsData);
  }, [data]);

  useEffect(() => {
    if (handleOkSaveButton && tabName === "features") {
      handleSaveClick();
    }
  }, [handleOkSaveButton, tabName]);
};
